import { useCallback } from 'react'
import { apiService } from '@/services/api'
import type { ProductEngagementEventName } from 'aeo-schema-generator-shared/utils'

export function useEngagementTracking() {
  return useCallback(
    (
      eventName: ProductEngagementEventName,
      metadata: Record<string, unknown> = {},
      ids: { domainId?: string | null; discoveredUrlId?: string | null } = {}
    ) => {
      // Engagement tracking is support intelligence only. Never block UX.
      //
      // The try/catch is NOT redundant with the .catch below. A synchronous
      // failure — the method missing, the api module not initialised — throws
      // before there is a promise to attach .catch to, so it landed in the
      // caller's event handler and took down the very action it was measuring.
      // Four page-setup tests failed that way, each by the setup never running.
      try {
        apiService
          .trackEngagementEvent({
            eventName,
            domainId: ids.domainId,
            discoveredUrlId: ids.discoveredUrlId,
            metadata,
          })
          ?.catch(() => {})
      } catch {
        // Same reason: a broken measurement must stay invisible to the user.
      }
    },
    []
  )
}
